import { useLocation, useNavigate } from 'react-router-dom';
import TabsComponent from '../../components/common/Tabs.component';
import ContactsListPage from '../contacts/list/ContactsList.page';
import suppliers from '../../module/suppliers';
import users_crew from '../../module/users_crew';
import users_nautica from '../../module/users_nautica';
import { useEffect, useMemo, useState } from 'react';

const DirectoryListPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathToTabIndex = {
    '/customers': 0,
    '/suppliers': 1,
    '/na': 2,
  };

  const tabIds = ['customers', 'suppliers', 'na'];

  const currentTab = pathToTabIndex[location.pathname] ?? 0;
  const currentTabId = tabIds[currentTab];
  const [valueTab, setValueTab] = useState(currentTab);

  const optionsTabs = useMemo(
    () => [
      {
        id: 0,
        label: 'CUSTOMERS',
        children: (
          <ContactsListPage module={users_crew} currentTabId={currentTabId} />
        ),
      },
      {
        id: 1,
        label: 'SUPPLIERS',
        children: (
          <ContactsListPage module={suppliers} currentTabId={currentTabId} />
        ),
      },
      {
        id: 2,
        label: 'NA',
        children: (
          <ContactsListPage
            module={users_nautica}
            currentTabId={currentTabId}
          />
        ),
      },
    ],
    [currentTabId]
  );

  const handleTabChange = (tabIndex) => {
    const tabRoutes = ['/customers', '/suppliers', '/na'];
    navigate(tabRoutes[tabIndex]);
  };

  const handleChange = (newValue) => {
    setValueTab(newValue);
    handleTabChange(newValue);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const tabIndex = optionsTabs?.findIndex((tab) =>
      currentPath.includes(tab.id)
    );
    if (tabIndex !== -1) {
      setValueTab(tabIndex);
    }
  }, [location.pathname, optionsTabs]);

  return (
    <TabsComponent
      defaultTab={valueTab}
      onChangeTab={handleChange}
      tabs={optionsTabs}
    />
  );
};

export default DirectoryListPage;
